import Swal from "sweetalert2";

export default function msgAlerta(titulo, mensaje, icono, fnConfirmacion = null, question = true) {
  if (fnConfirmacion) {
    if (question) {      
      return (
        Swal.fire({
          title: titulo,
          html: mensaje,        
          icon: icono,
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          confirmButtonColor: '#2e7d32',
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#dc3545', 
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed)
            fnConfirmacion()
        })
      )
    } else {
      return (
        Swal.fire({
          title: titulo,
          html: mensaje,
          icon: icono,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#0288d1',
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed)
            fnConfirmacion()
        })
      )
    }
  } else {
    return (
      Swal.fire({
        title: titulo,
        html: mensaje,
        timer: 60000,
        icon: icono,
        confirmButtonColor: '#0288d1',
        confirmButtonText: 'Aceptar',
      })
    )
  }
}